import React, { createContext, useReducer, useContext } from 'react';


const User = JSON.parse(localStorage.getItem('User'))
const SideMenuStatus = localStorage.getItem('side-menu-status')


// Initial state for the context
const initialState = {
  userInfo: {
    fullName: User?.fullName || '',
    firstName: User?.firstName || '',
    phoneNumber: User?.phoneNumber || '',
    email: User?.email || '',
    token: User?.token || '',
    profileStatus: User?.profileStatus || false,
    DSPProfileStatus: User?.DSPProfileStatus || false,
    flipkartProfileStatus: User?.flipkartProfileStatus || false,
    myntraProfileStatus: User?.myntraProfileStatus || false,
    blinkitProfileStatus: User?.blinkitProfileStatus || false,
    instamartProfileStatus : User?.instamartProfileStatus || false,
    amcStatus : User?.amcStatus || false,
    zeptoProfileStatus: User?.zeptoProfileStatus || false,
    bigbasketProfileStatus: User?.bigbasketProfileStatus || false,
    isWhatsappVerified: User?.isWhatsappVerified || false,
  },
  selectedAmazon: {},
  selectedFlipkart: {},
  billingInfo: {
    durationId: "",
    endDate : "",
    isTrail: 0,
    message: "",
    nextPayment: "",
    numOfAdAccount: 1,
    numOfUserCount: 1,
    planName: "Startup",
    startDate: ""
  },
  lockStatus: 1,
  sidebarCollapsed: true,
  overlay: {},
  dateInfo: {},
  jobId: (() => {
    try {
      const s = localStorage.getItem('Processing-Job-ID');
      if (!s) return [];
      const p = JSON.parse(s);
      return Array.isArray(p) ? p : [p];
    } catch {
      const s = localStorage.getItem('Processing-Job-ID');
      return s ? [s] : [];
    }
  })(),
  sweetAlertActionTriggered: false,
  doBulkUpdateData: null,
  openVerifyWhatsappModal: false
};

// Define the reducer function
const reducer = (state, action) => {
  switch (action.type) {
    case 'UPDATE_USER':
      return { ...state, userInfo: { ...state.userInfo, ...action.payload } };
    case 'UPDATE_BILLING_INFO':
      return { ...state, billingInfo: { ...state.billingInfo, ...action.payload } };
    case 'UPDATE_LOCK_STATUS':
      return { ...state, ...action.payload };
    case 'TOGGLE_SIDEBAR':
      return { ...state, sidebarCollapsed: !state.sidebarCollapsed };
    case 'SET_SIDEBAR_COLLAPSED':
      return { ...state, sidebarCollapsed: action.payload };
    case 'UPDATE_OVERLAY_MODAL':
      return { ...state, overlay: { ...state.overlay, ...action.payload } };
    case 'UPDATE_DATE_AVAILABLE':
      return { ...state, dateInfo: { ...action.payload } };
    case 'UPDATE_JOB_ID': {
      const newJobId = action.payload;
      const existingJobIds = Array.isArray(state.jobId) ? state.jobId : [];
      const updatedJobIds = [...existingJobIds, newJobId];
      localStorage.setItem('Processing-Job-ID', JSON.stringify(updatedJobIds));
      return { ...state, jobId: updatedJobIds };
    }
    case 'REMOVE_JOB_ID': {
      const jobIdToRemove = action.payload;
      const existingJobIds = Array.isArray(state.jobId) ? state.jobId : [];
      const updatedJobIds = existingJobIds.filter(id => id !== jobIdToRemove);
      
      // Update localStorage
      if (updatedJobIds.length > 0) {
        localStorage.setItem('Processing-Job-ID', JSON.stringify(updatedJobIds));
      } else {
        localStorage.removeItem('Processing-Job-ID');
      }
      
      return { ...state, jobId: updatedJobIds };
    }
    case 'SET_SWEET_ALERT_ACTION_TRIGGERED':
      return { ...state, sweetAlertActionTriggered: action.payload };
    case 'SET_DO_BULK_UPDATE_DATA':
      return { ...state, doBulkUpdateData: action.payload };
    case 'OPEN_VERIFY_WHATSAPP_MODAL':
      return { ...state, openVerifyWhatsappModal: action.payload };
    default:
      return state;
  }
};

// Create the context
const CommonContext = createContext();

// Create a custom hook to use the context
const useCommonContext = () => {
  const context = useContext(CommonContext);
  if (!context) {
    throw new Error('useCommonContext must be used within a CommonProvider');
  }
  return context;
};

// Create the provider component
const CommonProvider = ({ children }) => {
  const [commonState, commonDispatch] = useReducer(reducer, initialState);

  return (
    <CommonContext.Provider value={{ commonState, commonDispatch }}>
      {children}
    </CommonContext.Provider>
  );
};

export { CommonProvider, useCommonContext };